export const processField = {
  phone: (phone) => phone.replace(/[^0-9]/g, ''),
  form({ phone, ...payload }) {
    return {
      ...payload,
      phone: this.phone(phone),
    };
  },
};
